import { useQueryCore } from "@/hooks/useQueryCore";
import { getVisit } from "@/lib/api";

export function useVisitDetail(id) {
  const { data, loading, error, refetch } = useQueryCore({
    key: ["visit-detail", id],
    enabled: !!id,
    queryFn: () => getVisit(id),
    // Reuse the same Dexie key that api.js getVisit already writes to.
    // On cold start, Phase 0 finds the previously-cached visit and paints
    // the page instantly; Phase 1 refreshes silently from network.
    cacheKey: id ? `visit_${id}` : null,
  });

  // useQueryCore initializes data as []. Guard against the pre-resolution
  // [] state so "not found" never flashes before the first fetch completes.
  const resolved = !Array.isArray(data);

  return {
    visit:   resolved ? (data ?? null) : null,
    loading: loading || !resolved,
    error,
    refetch,
  };
}
